<template>
  <div>
    <DashboardHeader title="Invoices & Quotes">
      <div :class="isMobile ? 'mt-2' : ''">
        <v-card>
          <v-tabs v-model="tab" :background-color="getThemeColor" centered dark>
            <v-tabs-slider :color="getSecondaryColor"></v-tabs-slider>
            <v-tab href="#tab-1" @click="refreshInvoicesAndQuotesData()">
              Dashboard
            </v-tab>
            <v-tab href="#tab-2"> Create Invoices </v-tab>
            <v-tab href="#tab-3"> Create Quotes </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item v-for="i in 3" :key="i" :value="'tab-' + i">
              <v-card v-if="i == 1">
                <InvoicesAndQuotesDashboard
                  @refresh-data="refreshInvoicesAndQuotesData"
                  :data="data"
                  @items-deleted="refreshInvoicesAndQuotesDataAfterDelete"
                  @edit-invoice="editSelectedInvoice"
                  @edit-quote="editSelectedQuote"
                ></InvoicesAndQuotesDashboard>
              </v-card>

              <v-card v-else-if="i == 2">
                <CreateInvoice
                  :selectedInvoiceProp="selectedItem"
                  :docType="'Invoice'"
                ></CreateInvoice>
              </v-card>

              <v-card v-else-if="i == 3">
                <CreateInvoice
                  :docType="'Quotation'"
                  :selectedInvoiceProp="selectedItem"
                ></CreateInvoice>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </div>
    </DashboardHeader>
  </div>
</template>

<script>
import invoicesAndQuotesJs from "@/plugins/invoicesAndQuotes";
import DashboardHeader from "@/components/DashboardHeader.vue";
import CreateInvoice from "./CreateInvoice.vue";
import InvoicesAndQuotesDashboard from "./InvoicesAndQuotesDashboard.vue";

export default {
  async mounted() {
    await this.getInvoicesAndQuotesData();
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
  },
  components: {
    DashboardHeader,
    CreateInvoice,
    //CreateQuote,
    InvoicesAndQuotesDashboard,
  },
  data: () => ({
    tab: null,
    data: null,
    selectedInvoice: null,
    selectedQuote: null,
    selectedItem: null,
  }),
  methods: {
    async refreshInvoicesAndQuotesData() {
      window.location.reload();
      await this.getInvoicesAndQuotesData();
    },
    async refreshInvoicesAndQuotesDataAfterDelete() {
      await this.getInvoicesAndQuotesData();
    },
    async getInvoicesAndQuotesData() {
      this.$store.commit("setLoader", true);
      this.data = await invoicesAndQuotesJs.getInvoicesAndQuotesData();
      this.$store.commit("setLoader", false);
    },
    editSelectedInvoice(invoice) {
      this.selectedInvoice = invoice;
      this.selectedItem = invoice;
      this.tab = "tab-2";
    },
    editSelectedQuote(quote) {
      this.selectedQuote = quote;
      this.selectedItem = quote;
      this.tab = "tab-2";
    },
  },
};
</script>

<style></style>
